import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { pick } from 'lodash';

import { CreateMainTemplate } from '../../components/Templates/CreateGame/CreateMainTemplate';
import { useSessionStore } from '../../stores/SessionStore';
import { useUserStore } from '../../stores/UserStore';
import { StaminaType } from '../../constants/currencies';
import { BalanceType } from '../../models/Base/Balance';
import { CurrencyAmount } from '../../components/Molecules/AssetDisplayBar';
import { useDraftStore } from '../../stores/DraftStore';

const { fetchAllowance, getCurrentUser } = useUserStore.getState();

const CreateMainScreen: React.FC = () => {
  const navigate = useNavigate();
  const userId = useSessionStore((state) => state.activeUserId);
  const profile = useUserStore((state) => state.getProfile(userId ?? ''));
  const { balance } = useUserStore((userState) => {
    const account = userState.getAccount(userId ?? '');
    return {
      ...pick(account, ['balance']),
    };
  });

  useEffect(() => {
    getCurrentUser().catch(console.error);
    fetchAllowance().catch(console.error);
  }, []);

  const allowance = useUserStore((store) => store.getAllowance());

  const currencies = useMemo(() => {
    const tokenNum = balance?.creationToken ?? 0;
    const staminaNum =
      allowance?.allowances.creatorPlan.quantities.creationToken ?? 24;
    const currency: CurrencyAmount[] = [
      { amount: tokenNum, type: BalanceType.CreationToken },
      { amount: staminaNum, type: StaminaType.CreationStamina },
    ];
    return currency;
  }, [
    allowance?.allowances.creatorPlan.quantities.creationToken,
    balance?.creationToken,
  ]);

  const onCreateOwn = useCallback(() => {
    useDraftStore.getState().clear();
    navigate('/create/memory-game/select-type');
  }, [navigate]);

  const onProvideContent = useCallback(() => {
    navigate('/create/memory-game/help');
  }, [navigate]);

  return (
    <CreateMainTemplate
      profile={profile}
      currencies={currencies}
      onCreateOwn={onCreateOwn}
      onProvideContent={onProvideContent}
    />
  );
};

export default CreateMainScreen;
